import { render, staticRenderFns } from "./GenericFilter.vue?vue&type=template&id=537596be&scoped=true&"
import script from "./GenericFilter.vue?vue&type=script&lang=js&"
export * from "./GenericFilter.vue?vue&type=script&lang=js&"
import style0 from "./GenericFilter.vue?vue&type=style&index=0&id=537596be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537596be",
  null
  
)

export default component.exports